const AppReducer = (state, action) => {
  switch (action.type) {
    case "SET_Data":
      return {
        ...state,
        userData: action.payload,
      };
    default:
      return state;
  }
};

export default AppReducer;
